import { Component, OnInit } from '@angular/core';
import { faBars, faXmark } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-main-nav-mobile',
  templateUrl: './main-nav-mobile.component.html',
  styleUrls: ['./main-nav-mobile.component.scss']
})
export class MainNavMobileComponent implements OnInit {
  faBars = faBars;
  faXmark = faXmark;
  public showBurgerMenu = false;

  constructor() { }

  ngOnInit(): void {
  }

}
